// Update sort option labels to clarify height sorting
document.addEventListener('DOMContentLoaded', function() {
  // Function to update sort option labels
  function updateSortLabels() {
    // Find all sort dropdowns (both desktop and mobile)
    const sortSelects = document.querySelectorAll('select[name="sort_by"]');
    
    sortSelects.forEach(select => {
      // Find the option with value "manual" or empty value (which is the default/featured sort)
      const options = select.querySelectorAll('option');
      
      options.forEach(option => {
        // The "Featured" option typically has value "manual" or sometimes ""
        if (option.value === 'manual' || option.value === '') {
          // Update the text to indicate height sorting
          if (option.textContent.includes('Featured')) {
            option.textContent = 'Height (Tallest to Shortest)';
          }
        }
      });
    });
  }
  
  // Run on initial load
  updateSortLabels();
  
  // Also run when facets are updated (for AJAX filtering)
  document.addEventListener('facets:loaded', updateSortLabels);
});